import { RiskImpact } from '@/app/components/action-plan/types';

const overall = 'overall';

export function getInterventionHighestRisk(riskImpact: Array<RiskImpact>) {
  const cancersAffected = riskImpact.filter(({ cancerType }) => cancerType !== overall);
  const overallRisk = riskImpact.reverse().find(({ cancerType }) => cancerType === overall);

  const highestImpactCancer = cancersAffected.reduce(
    (leadingCancer, nextCancer) => (leadingCancer.impact > nextCancer.impact ? leadingCancer : nextCancer),
    cancersAffected[0]
  );
  const reducedRisk = highestImpactCancer ?? overallRisk;

  const otherCancers = cancersAffected?.length ? cancersAffected.length - 1 : 0;

  return { reducedRisk, otherCancers };
}
